export default __webpack_public_path__ + "static/fb-af53afabdb88520830baa23d26f3541d.png";